export default __webpack_public_path__ + "static/realWorldbg-5f7334c2fd62cd4d4c28db08ad4636b2.png";